import {gsap} from "gsap";

const animationOnce = (container) => {
   var loader = document.querySelector("#loader");
    const tl = gsap.timeline({
        defaults : {
            duration: 1,//duration 1 pour final
            ease: "power2.out",
        }
    });
    tl.set(container, {alpha:0})
    tl.fromTo(loader, {alpha:0}, {alpha:1, duration:2, delay:.3}) //duration = 2 pour final
  
    tl.to(loader, {autoAlpha:0, duration:2, delay:.3})//duration = 2 pour final
    tl.to(container, {alpha:1})

    return tl;
}

export default animationOnce;
